import * as React from 'react';
import {faChevronLeft, faChevronRight} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {gaLegacyCustomEvent} from '../../../client/ga/ga-legacy.functions';
import {UrlClass} from '../../tools/UrlClass';

interface PaginatorProps {
    baseURL?: string;
    currentPage: number;
    gaEventCategory?: `Order History Items`;
    itemsPerPage: number;
    onClick?: (pageNum: number) => void;
    skipSanitize?: boolean;
    totalItems: number;
}

export const Paginator = ({baseURL, currentPage, gaEventCategory, itemsPerPage, onClick, skipSanitize, totalItems}: PaginatorProps) => {
    const MAX_PAGE_LINKS = 5;
    const MAX_PAGE_LINKS_HALF = Math.floor(MAX_PAGE_LINKS / 2);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    /**
     * TBD
     * @param newPage
     */
    const buildUrl = (newPage: number) => {
        return UrlClass.addParam(sanitizeLinks(baseURL), `page`, `${newPage}`);
    };

    /**
     * TBD
     */
    const getPages = () => {
        const pages = [];
        let start: number;
        if (currentPage <= MAX_PAGE_LINKS_HALF) {
            start = 1;
        } else {
            if (currentPage >= totalPages - MAX_PAGE_LINKS_HALF) {
                start = Math.max(totalPages - MAX_PAGE_LINKS + 1, 1);
            } else {
                start = currentPage - MAX_PAGE_LINKS_HALF;
            }
        }
        const end = Math.min(start + MAX_PAGE_LINKS - 1, totalPages);
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    /**
     * TBD
     * @param url
     */
    const sanitizeLinks = (url: string) => {
        if (skipSanitize) {
            return url;
        }
        return encodeURI(url);
    };

    /**
     * Template
     */
    if (totalItems <= itemsPerPage) {
        return <div />;
    } else {
        return (
            <div>
                {currentPage > 1 && (
                    <a
                        aria-label="Previous Page"
                        className="tw-no-underline hover:tw-text-white hover:tw-no-underline tw-bg-gray-600 tw-text-white tw-rounded-[3px] tw-leading-normal tw-font-normal tw-text-base tw-py-[5px] tw-px-2.5 tw-my-0 tw-mr-[5px] tw-ml-0 tw-cursor-pointer"
                        href={baseURL ? buildUrl(currentPage - 1) : undefined}
                        onClick={() => {
                            if (onClick) {
                                onClick(currentPage - 1);
                            }
                        }}
                        role="button"
                    >
                        <FontAwesomeIcon
                            aria-hidden="true"
                            icon={faChevronLeft}
                        />
                    </a>
                )}
                {getPages().map((pageNumber, index) => (
                    <a
                        className={`tw-my-0 tw-mr-[5px] hover:tw-text-white hover:tw-no-underline tw-ml-0 tw-py-[5px] tw-px-2.5 tw-font-normal tw-text-base tw-no-underline tw-rounded-[3px] tw-leading-normal tw-cursor-pointer ${
                            currentPage === pageNumber
                                ? 'tw-bg-gray-600 tw-text-white'
                                : 'tw-bg-transparent tw-text-gray-650 hover:tw-bg-gray-600 hover:tw-text-white'
                        }`}
                        href={baseURL ? buildUrl(pageNumber) : undefined}
                        key={index}
                        onClick={() => {
                            if (onClick) {
                                onClick(pageNumber);
                            }
                            if (gaEventCategory) {
                                gaLegacyCustomEvent({
                                    eventCategory: gaEventCategory,
                                    eventAction: `Pagination`,
                                    eventLabel: `Page ${pageNumber} Selected`,
                                });
                            }
                        }}
                        role="button"
                    >
                        {pageNumber}
                    </a>
                ))}
                {currentPage < totalPages && (
                    <a
                        aria-label="Next Page"
                        className="tw-my-0 tw-mr-[5px] hover:tw-text-white hover:tw-no-underline tw-ml-0 tw-py-[5px] tw-px-2.5 tw-font-normal tw-text-base tw-no-underline tw-rounded-[3px] tw-leading-normal tw-cursor-pointer tw-bg-gray-650 tw-text-white"
                        href={baseURL ? buildUrl(currentPage + 1) : undefined}
                        onClick={() => {
                            if (onClick) {
                                onClick(currentPage + 1);
                            }
                        }}
                        role="button"
                    >
                        <FontAwesomeIcon
                            aria-hidden="true"
                            icon={faChevronRight}
                        />
                    </a>
                )}
            </div>
        );
    }
};
